import React, { useEffect, forwardRef } from 'react';

function MicroFrontend (
  { host, history, privileges, componentProps, containerId },
  ref
) {
  const commonName = 'CommonModule';
  useEffect(() => {
    const instanceId = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    const scriptId = `micro-frontend-script-${commonName}-${instanceId}`;

    const renderFunctionName = `renderCommonModule_${instanceId}`;
    
    const renderMicroFrontend = () => {
      const waitForContainer = (attempts = 0) => {
        const container = document.getElementById(containerId);
        if (container) {
          const renderFunction = window[renderFunctionName] || window[`renderCommonModule`];
          if (renderFunction) {
            renderFunction(
              containerId,
              history,
              privileges,
              componentProps,
              ref
            );
          }
        } else if (attempts < 10) {
          setTimeout(() => waitForContainer(attempts + 1), 50);
        }
      };
      
      waitForContainer();
    };

    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      renderMicroFrontend();
      return;
    }

    fetch(`${host}/asset-manifest.json`, {
      cache: 'no-cache',
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw new Error(`Failed to fetch asset manifest: ${res.status} ${res.statusText}`);
        }
        return res.json();
      })
      .then(manifest => {
        if (!manifest.files || !manifest.files['main.js']) {
          throw new Error('Invalid asset manifest: missing main.js');
        }

        const script = document.createElement('script');
        script.id = scriptId;
        script.crossOrigin = '';
        script.src = `${host}${manifest.files['main.js']}`;
        
        const link = document.createElement('link');
        link.id = `micro-frontend-link-${commonName}-${instanceId}`;
        link.crossOrigin = '';
        link.rel = 'stylesheet';
        link.href = `${host}${manifest.files['main.css']}`;
        
        script.onload = () => {
          setTimeout(renderMicroFrontend, 100);
        };
        
        document.head.appendChild(script);
        document.head.appendChild(link);
      });
    
    return () => {
      const unmountFunctionName = `unmount${commonName}_${instanceId}`;
      const unmountFunction = window[unmountFunctionName] || window[`unmount${commonName}`];
      
      if (unmountFunction) {
        unmountFunction(containerId);
      }
    };
  }, [host, history, privileges, componentProps, containerId]);

  return <section id={containerId} className={`${(componentProps?.type != 'AuditLog' || componentProps?.type != 'Notes') ? "commonModuleClass" : ""}`}/>;
}

MicroFrontend.defaultProps = {
  document,
  window
};

export default forwardRef(MicroFrontend);
